module.exports = __webpack_public_path__ + "static/media/facebookColor.00133b4c.svg";